// removed by extract-text-webpack-plugin
module.exports = {"root":"_1d5aK","rotate-scale":"_3qCKZ","rotate":"_2cwCm"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Spinner/Spinner.sass
// module id = ./src/elements/Spinner/Spinner.sass
// module chunks = 6